import React, {Component} from 'react';
import Select from "../Select/Select";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import ContentAccordion from "../../components/ContentAccordion/ContentAccordion";
import {REQUEST_FACILITIES_META_DATA} from "../../actions/facilitiesMetaActions";
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";

class FacilitiesInterlineDestinations extends Component {

  constructor(props) {
    super(props);
    this.state = {
      countries: [],
      destinations: []
    }
  }

  componentDidMount() {
    if (!Object.keys(this.props.facilitiesMeta).length > 0) {
      this.props.getFacilitiesMeta();
    }

    if (!this.props.rawFacilities) {
      this.props.getRawFacilities();
    }
  };

  handleRegionChange(region) {

    let countries = this.props.facilitiesMeta.interlineFacilities.countries.filter(country => {
      return region === country.region;
    }).map(country => {
      return {
        name: country.country
      }
    });

    this.setState({
      countries: countries,
      destinations: []
    });

  };

  handleCountryChange(countryName) {

    let destinations = [];

    let country = this.props.facilitiesMeta.interlineFacilities.countries.find(country => {
      return country.country === countryName;
    });

    let locations = [];

    country.states.forEach(state => {
      this.props.facilitiesMeta.interlineFacilities.locations.forEach(location => {
        if (location.state === state && location.country === countryName) {
          locations.push(location);
        }
      });
    });


    locations.forEach(location => {
      location.airports.forEach(airport => {
        destinations.push({
          airportCodeIATA: airport.code,
          state: location.state,
          city: airport.name
        });
      });
    });

    destinations.sort((a, b) => {
      if (a.city < b.city) {
        return -1;
      }
      if (a.city > b.city) {
        return 1;
      }
      return 0;
    });

    this.setState({
      destinations: destinations
    });

  }

  getPageView() {

    const regions = this.props.facilitiesMeta.interlineFacilities.regions ? this.props.facilitiesMeta.interlineFacilities.regions.map(region => {
      return {
        name: region.region
      }
    }) : [];

    regions.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return (
      <div className="interline-destinations-wrapper">
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/interline-destination-heading.html"
        />
        <div className="interline-destinations-destinations__heading">
          Destinations
        </div>
        <div className="interline-destinations-destinations-wrapper">
          <div className="interline-destinations-region-and-country">
            <Select
              hasPleaseSelectOption={true}
              name="region"
              title="Region"
              options={regions}
              onChange={(event) => {
                this.handleRegionChange(event.target.value)
              }}
              desktopWidth={'100%'}
              tabletWidth={'100%'}
              mobileWidth={'100%'}
            />
          </div>

          <div className="interline-destinations-region-and-country">
            <Select
              hasPleaseSelectOption={true}
              name="country"
              title="Country"
              options={this.state.countries}
              onChange={(event) => {
                this.handleCountryChange(event.target.value)
              }}
              resetOnPropsUpdate={true}
              desktopWidth={'100%'}
              tabletWidth={'100%'}
              mobileWidth={'100%'}
            />
          </div>

          <div className="interline-destinations-destination-info-wrapper">
            <ul className="unstyled-list interline-destinations-destination-info">
              {this.state.destinations.map(destination => {
                return destination ? <li key={destination.airportCodeIATA}
                                         style={{textTransform: "capitalize"}}>{destination.city.toLowerCase()}, {destination.state.toLowerCase()} ({destination.airportCodeIATA})</li> : null
              })}
            </ul>
          </div>

        </div>

        <div className="mbl pbm ptm">
          <ContentAccordion
            jsonDataUrl="./content/ship/page-components/accordion/interline-destinations.json"
          />
        </div>

      </div>
    );
  }

  render() {
    return this.props.rawFacilities && this.props.facilitiesMeta.interlineFacilities ? this.getPageView() : <Skeleton type="LONG_CONTENT_PAGE"/>;
  }
}

const mapStateToProps = (state) => {
  return {
    facilitiesMeta: state.facilitiesMetaData,
    rawFacilities: state.facilitiesData.rawFacilities
  }
};

const mapDispatchToProps = dispatch => ({
  getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA}),
  getFacilitiesMeta: () => dispatch({type: REQUEST_FACILITIES_META_DATA})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilitiesInterlineDestinations));


// WEBPACK FOOTER //
// ./src/components/FacilitiesInterlineDestinations/FacilitiesInterlineDestinations.js